export default function ({ $axios, app, redirect }) {
    $axios.onError(async error => {
        // 標準のアラートを表示するか否かをURLで判別する。
        // 独自のエラーハンドリングを行なう場合は含まない。
        if ([].concat(
            // page
            app.$objutil.flattenObjectValues(app.$page.user),
            app.$objutil.flattenObjectValues(app.$page.tenantAdmin),
            // api
            app.$api.common.getTerms, app.$api.common.agreeTerms,
            app.$objutil.flattenObjectValues(app.$api.user),
            app.$objutil.flattenObjectValues(app.$api.tenantAdmin),
            app.$objutil.flattenObjectValues(app.$api.systemAdmin),
        ).includes(error.response.config.url.split('?').shift())) {
            switch (error.response.status) {
                case 401:
                    if (process.browser) {
                        app.store.commit('app/setExpired', true);
                    } else {
                        await app.$auth.logout();
                        redirect(app.$page.login, {expired: true});
                    }
                    break;
                case 404:
                    app.$alert.error('該当のデータは削除されたか存在しません。\n再読み込みをして、再度お試しください。');
                    break;
                case 422:
                    app.$alert.error('入力値が異常です。もう一度やり直してください。\nこのメッセージが何度も表示される場合は、お手数ですがテレワーク兵庫ヘルプデスクまでご連絡ください。');
                    break;
                case 423:
                    app.$alert.error('このメールアドレスは一度使用されているため使用することができません。\n登録を行いたい場合は、お手数ですがテレワーク兵庫ヘルプデスクまでご連絡ください。');
                    break;
                case 440:
                    app.$alert.error('ユーザ登録上限に達しましたので、これ以上登録することはできません。');
                    break;
                case 500:
                default:
                    app.$alert.error('サーバエラーが発生しました');
            }
        }
        return Promise.reject(error);
    })
}
